import { render, staticRenderFns } from "./Institutions.vue?vue&type=template&id=c1e2649a&"
import script from "./Institutions.vue?vue&type=script&lang=js&"
export * from "./Institutions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports